/**
 * Home puts the cursor at the end of a restored draft so the user continues typing
 * where they left off and the command menu reopens for a restored `/co`.
 */
export function createHomeComposerFocusHandle(composerRef) {
    function focus() {
        composerRef.current?.focus({ position: 'end' });
    }
    function getFocusState() {
        return composerRef.current?.getFocusState() ?? null;
    }
    return { focus, getFocusState, position: 'end' };
}
//# sourceMappingURL=createHomeComposerFocusHandle.js.map